<div class="mb-3">
  <div class="section-banner">
    <span class="banner-icon">✱</span>
    <span>Diagnósticos / Condiciones ({{ conditions().length }})</span>
  </div>
  <div class="section-banner-body">
    @for (cond of conditions(); track cond.id; let idx = $index) {
      @let codeCoding = cond.code?.coding?.[0];
      @let clinicalCoding = cond.clinicalStatus?.coding?.[0];
      @let verifCoding = cond.verificationStatus?.coding?.[0];
      @let catCoding = cond.category?.[0]?.coding?.[0];
      @let estadoBadge = getEstadoBadge(clinicalCoding?.display || clinicalCoding?.code || '');

      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center gap-2">
          <span
            class="badge bg-secondary rounded-circle"
            style="
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            #{{ idx + 1 }}
          </span>
          <strong>{{
            cond.code?.text || codeCoding?.display || codeCoding?.code || 'Sin nombre'
          }}</strong>
        </div>
        @if (clinicalCoding) {
          <span class="badge {{ estadoBadge.color }} px-3 py-2">
            {{ estadoBadge.label }}
          </span>
        }
      </div>

      @if (codeCoding?.code) {
        <p class="mb-2"><strong>Código ICD-10:</strong> {{ codeCoding!.code }}</p>
      }
      @if (catCoding) {
        <p class="mb-2"><strong>Categoría:</strong> {{ catCoding.display || catCoding.code }}</p>
      }
      @if (verifCoding) {
        @let verifBadge = getVerifBadge(verifCoding.display || verifCoding.code || '');
        <p class="mb-2"><strong>Estado de Verificación:</strong> {{ verifBadge.label }}</p>
      }

      @if (!$last) {
        <hr />
      }
    }
  </div>
</div>
<hr />
